import { CallbackFieldType } from '../interfaces/journey.interface';
import { CallbackTypeStrategy } from './callback-type-strategy';

class ExactTypeStrategy implements CallbackTypeStrategy {
  constructor(
    public readonly id: string,
    private readonly callbackTypes: string[],
    private readonly fieldType: CallbackFieldType,
  ) {}

  supports(callbackType: string): boolean {
    return this.callbackTypes.includes(callbackType);
  }

  resolveFieldType(): CallbackFieldType {
    return this.fieldType;
  }
}

export const DEFAULT_CALLBACK_TYPE_STRATEGIES: CallbackTypeStrategy[] = [
  new ExactTypeStrategy('password', ['PasswordCallback', 'ValidatedCreatePasswordCallback'], 'password'),
  new ExactTypeStrategy('text', ['NameCallback', 'StringAttributeInputCallback'], 'text'),
  new ExactTypeStrategy('otp', ['NumberAttributeInputCallback'], 'otp'),
  new ExactTypeStrategy('choice', ['ChoiceCallback'], 'choice'),
  new ExactTypeStrategy('confirmation', ['ConfirmationCallback'], 'confirmation'),
  new ExactTypeStrategy('info', ['TextOutputCallback'], 'info'),
  new ExactTypeStrategy('hidden', ['HiddenValueCallback', 'MetadataCallback'], 'hidden'),
  new ExactTypeStrategy('webauthn', ['WebAuthn'], 'webauthn'),
];
